<template>
<!--新建案例页面总体信息-->
<el-form class="totalForm" status-icon ref="total" label-width="45%" v-model="total" v-loading="loading">

  <div class="formDo">
    <!--占位空白盒子-->
  </div>

  <div class="formMsg">
    <!--表单组-->
    <cli-form
      :formItem="total"
    ></cli-form>
  </div>

  <div class="formButton">
    <!--按钮操作区-->
    <el-button-group>
      <el-button icon="el-icon-check" :plain="true" @click="submit">保存信息</el-button>
      <el-button :disabled="next" @click="nextStep">下一步<i class="el-icon-arrow-right el-icon--right"></i></el-button>
    </el-button-group>
  </div>

</el-form>
</template>

<script>
import qs from 'qs'
import bus from './bus'
import arrayData from '../assets/javascript/dataProcess'
import cliForm from '../assets/components/form'

export default {
  name: "newCase_total",
  components:{
    cliForm
  },
  data() {
    return {
      /*加载动画*/
      loading: false,
      next: true,
      /*渲染数组*/
      total: []
    }
  },
  methods: {
    submit() {
      let formdata = {};
      if (this.total[0].value === '' || this.total[1].value === '' || this.total[2].value === '' || this.total[3].value === '' || this.total[4].value === '' || this.total[5].value === '' || this.total[6].value === '' || this.total[7].value === '' || this.total[8].value === '' || this.total[9].value === '') {
        for (let i = 0; i < 7; i++) {
          if (this.total[i].value === "") {
            this.$set(this.total[i], "warning", 1);
            this.$set(this.total[i], "warningMsg", "必填信息不得为空");
          }
        }
      } else {
        for (let i = 0; i < this.total.length; i++) {
          formdata[this.total[i].name] = this.total[i].value;
        }
        this.loading = true;
        this.$http.post(
            '/nais/total',
            qs.stringify(formdata), {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              }
            }
          )
          .then((res) => {
            this.$message({
              message: "总体信息保存成功",
              type: 'success',
              center: true,
              duration: 1000
            });
            this.next = false;
            this.$nextTick(
              this.loading = false,
            );
          })
          .catch((err) => {
            console.log(err);
            this.$nextTick(
              this.loading = false,
            );
          });
        bus.$emit('caseNumber', this.total[0].value);
        bus.$emit('participantsNum', this.total[3].value);
        this.next = false;
      }
    },
    /*下一步*/
    nextStep() {
      bus.$emit('activeTotal', 1);
    }
  },
  created() {
    let length = arrayData.data1.total.length;
    for (let i = 0; i < length; i++) {
      arrayData.data1.total[i].value = '';
    }
    this.total = arrayData.data1.total;
  }
}
</script>

<style scoped>
.totalForm {
  width: 98%;
  height: 89%;
  margin-top: 0.5%;
  background-color: #F5F7FA;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
}

.formDo {
  height: 10%;
}

.formMsg {
  width: calc(100% - 10px);
  height: 78%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-content: flex-start;
  /*修改*/
  padding-right: 10px;
  overflow-y: auto;
}

.formButton {
  width: 100%;
  height: 10%;
  margin-top: 1%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.el-form-item {
  width: 33%;
}

.el-form-item__content {
  width: calc(100% - 45%);
}

.el-input {
  width: 100%;
}

.el-select {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/data/newCase_total.vue